import { useDialog, postMessageClose, String_t } from "mfe-lib-bfo-shared";

export const useDefaultNetworkError = () => {
    const { openDialog } = useDialog();

    const title = String_t("ui.dialogErrors.somethingIsntRight.title", "stitcher");
    const message = String_t("ui.dialogErrors.somethingIsntRight.description", "stitcher");
    const buttonLabel = String_t("ui.dialogErrors.somethingIsntRight.buttonLabel", "stitcher");

    return () => {
        const errorMessage =  `${message} [NET0003]`

        openDialog({
            title,
            message: errorMessage,
            primaryBtnLabel: buttonLabel,
            iconType: "system-downtime",
            onPrimaryClick: () => {
                postMessageClose();
            },
            onCloseBtn: "primary",
        });
    };
};
